module.exports = __webpack_public_path__ + "3e924b8913e96783632f7d918989ecfe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/gavel.png
// module id = 2533
// module chunks = 0